module.exports = __webpack_public_path__ + "static/logo-plant-food-82b7c75533ed068bd9e94060711e428e.png";